<!-- eslint-disable vue/require-prop-types -->
<!-- eslint-disable vue/html-closing-bracket-newline -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/html-indent -->

<template>
    <div :class="[props.class]">
        <h3 class="text-base md:text-lg font-semibold">
            Expiration
        </h3>
        <p class="text-slate-500 text-xs md:text-sm">
            All expired incomplete documents will be voided automatically.
        </p>

        <div class="">
            <div class="flex gap-3">
                <label class="form-control w-full max-w-xs">
                    <div class="label px-0">
                        <span class="text-xs md:text-sm label-text">Days until envelopes expired</span>
                    </div>
                    <select v-model="selectNumberDay" class="select select-sm select-bordered bg-cs-gray-lv-0 max-w-xs">
                        <option disabled selected>Select expiration date</option>
                        <option v-for="option in options" :key="option.value" :value="option.value">
                            {{ option.label }}
                        </option>
                    </select>
                </label>

                <label v-if="isCustomDay" class="form-control w-1/3 max-w-xs">
                    <div class="label px-0">
                        <span class="text-xs md:text-sm label-text">Number of days</span>
                    </div>
                    <input v-model="customNumberOfDay" type="number" placeholder="Type number here"
                        class="input input-sm input-bordered bg-cs-gray-lv-0 w-full max-w-xs" min="1">
                </label>
            </div>

            <div class="label px-0">
                <input type="hidden" name="expired_at" :value="ISOformattedExpiredAt">

                <p v-if="selectNumberDay !== '-'" class="label-text text-xs md:text-sm ">
                    Envelope will expire on:
                    <span class="font-semibold">
                        {{ expiredAtHumanized }}
                    </span>
                </p>
                <p v-else class="text-xs md:text-sm label-text">
                    Envelope will not expire
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { format } from 'date-fns'
import { defineProps, ref, watch, onMounted, computed } from 'vue'

const props = defineProps(['class'])

const expiredAt = ref()
const customNumberOfDay = ref(0)
const selectNumberDay = ref('-')
const isCustomDay = ref(false)

const options = [
    { value: '5', label: '5 Days' },
    { value: '10', label: '10 Days' },
    { value: '15', label: '15 Days' },
    { value: '30', label: '30 Days' },
    { value: '60', label: '60 Days' },
    { value: 'custom', label: 'Custom days' },
    { value: '-', label: 'No Expiration Date' }
]

function addDaysToBaseDate(baseDate, days) {
    let actualBaseDate = baseDate

    if (typeof baseDate === 'string') {
        actualBaseDate = new Date(baseDate)
    }

    if (isNaN(actualBaseDate.getTime())) {
        console.error('Invalid base date string provided:', baseDate)
        return null
    }
    return new Date(actualBaseDate.getTime() + days * 24 * 60 * 60 * 1000)
}

onMounted(() => {
    const sendLaterAt = localStorage.getItem('send_later_at')
    const baseDate = sendLaterAt || new Date()

    if (selectNumberDay.value === '-' && selectNumberDay.value !== 'custom') {
        expiredAt.value = addDaysToBaseDate(
            baseDate,
            parseInt(selectNumberDay.value)
        )
    }

    if (selectNumberDay.value === 'custom') {
        expiredAt.value = addDaysToBaseDate(
            baseDate,
            parseInt(customNumberOfDay.value)
        )
    }
})

watch(selectNumberDay, (newVal) => {
    const sendLaterAt = localStorage.getItem('send_later_at')
    const baseDate = sendLaterAt || new Date()

    if (newVal === 'custom') {
        expiredAt.value = ''
        isCustomDay.value = true
    } else if (newVal === '-') {
        expiredAt.value = ''
        isCustomDay.value = false
    } else {
        expiredAt.value = addDaysToBaseDate(baseDate, parseInt(newVal))
        isCustomDay.value = false
    }
})

watch(customNumberOfDay, (newVal) => {
    const sendLaterAt = localStorage.getItem('send_later_at')
    const baseDate = sendLaterAt || new Date()

    let daysToAdd = parseInt(newVal)
    if (isNaN(daysToAdd) || daysToAdd < 1) {
        daysToAdd = 1
        customNumberOfDay.value = 1
    }

    expiredAt.value = addDaysToBaseDate(baseDate, daysToAdd)
})

const ISOformattedExpiredAt = computed(() => {
    try {
        if (expiredAt.value instanceof Date && !isNaN(expiredAt.value.getTime())) {
            return new Date(expiredAt.value.setHours(0, 0, 0, 0)).toISOString()
        }
        return ''
    } catch (error) {
        console.error('Error formatting ISOformattedExpiredAt:', error)

        return ''
    }
})

const expiredAtHumanized = computed(() => {
    try {
        if (ISOformattedExpiredAt.value) {
            return format(new Date(ISOformattedExpiredAt.value), 'dd-MM-yyyy')
        }
        return ''
    } catch (error) {
        console.error('Error formatting expiredAtHumanized:', error)
        return ''
    }
})
</script>
